'use es6';

import { combineReducers } from 'redux';
import SeamlessImmutable from 'seamless-immutable';
import { FINDER_ASSETS_SEARCH_FETCH, FINDER_SHOW_RECENTLY_EDITED, FINDER_SHOW_RECENTLY_DELETED, FINDER_ASSETS_SEARCH_SELECT_ASSET } from 'DesignData/actions/ActionTypes';
import { EMPTY_ARRAY } from 'DesignData/lib/array';

const makeSearchResults = () => {
  const isFetching = (state = null, action) => {
    switch (action.type) {
      case FINDER_ASSETS_SEARCH_FETCH:
        {
          const {
            assets,
            error
          } = action;
          return !(assets || error);
        }

      default:
        {
          return state;
        }
    }
  };

  const fetchError = (state = null, action) => {
    switch (action.type) {
      case FINDER_ASSETS_SEARCH_FETCH:
        {
          return action.error || null;
        }

      default:
        {
          return state;
        }
    }
  };

  const offset = (state = null, action) => {
    switch (action.type) {
      case FINDER_ASSETS_SEARCH_FETCH:
        {
          const {
            offset: responseOffset
          } = action;
          return responseOffset || 0;
        }

      default:
        {
          return state;
        }
    }
  };

  const total = (state = null, action) => {
    switch (action.type) {
      case FINDER_ASSETS_SEARCH_FETCH:
        {
          const {
            total: responseTotal
          } = action;
          return responseTotal !== undefined ? responseTotal : state;
        }

      default:
        {
          return state;
        }
    }
  };

  const assetIds = (state = EMPTY_ARRAY, action) => {
    switch (action.type) {
      case FINDER_ASSETS_SEARCH_FETCH:
        {
          const {
            assets
          } = action;

          if (assets && assets.length) {
            return SeamlessImmutable(assets.map(el => el.id));
          }

          return EMPTY_ARRAY;
        }

      default:
        {
          return state;
        }
    }
  };

  const activeAsset = (state = SeamlessImmutable({
    activeIndex: null,
    activeAssetId: null
  }), action) => {
    switch (action.type) {
      case FINDER_ASSETS_SEARCH_FETCH:
        {
          const {
            assets = []
          } = action;

          if (!assets.length) {
            return state;
          }

          return state.merge({
            activeIndex: 0,
            activeAssetId: assets[0].id
          });
        }

      case FINDER_ASSETS_SEARCH_SELECT_ASSET:
        {
          const {
            activeIndex,
            searchLength
          } = state;
          if (!searchLength) return state;
          const {
            searchResults,
            reverse
          } = action;
          let newIndex;

          if (reverse) {
            newIndex = (activeIndex + 1) % searchLength;
          } else {
            newIndex = activeIndex - 1 < 0 ? searchLength - 1 : activeIndex - 1;
          }

          const newActiveAssetId = searchResults[newIndex];
          return state.merge({
            activeIndex: newIndex,
            activeAssetId: newActiveAssetId
          });
        }

      default:
        {
          return state;
        }
    }
  };

  return combineReducers({
    isFetching,
    fetchError,
    offset,
    total,
    assetIds,
    activeAsset
  });
};

const searchResults = makeSearchResults();

function showRecentlyEdited(state = false, action) {
  switch (action.type) {
    case FINDER_SHOW_RECENTLY_EDITED:
      {
        return action.show;
      }

    default:
      return state;
  }
}

function showRecentlyDeleted(state = false, action) {
  switch (action.type) {
    case FINDER_SHOW_RECENTLY_DELETED:
      {
        return action.show;
      }

    default:
      return state;
  }
}

export default combineReducers({
  searchResults,
  showRecentlyEdited,
  showRecentlyDeleted
});